import React, { useEffect, useState } from "react";
import { Switch, Table, Tag } from "antd";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { postRequest } from "../../services/mainApp.service";

const OrderMode = () => {
  const [orderModes, setOrderModes] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.authReducer);

useEffect(() => {
  const controller = new AbortController();
  let isMounted = true; // <-- track mount status

  const fetchOrderModes = async () => {
    setLoading(true);
    try {
      const response = await postRequest(
        "/OrderModeCompanyMapping",
        {
          OperationId: 1,
          CompanyId: userData.CompanyId,
          UserId: userData.UserId,
          UserIP: userData.UserIP,
        }
      );

      if (isMounted) {
        setOrderModes(response?.data?.DataSet?.Table || []);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Failed to load order modes", error);
      }
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }
  };

  fetchOrderModes();

  return () => {
    controller.abort();
    isMounted = false; // <-- prevent state update
  };
}, []);


  const handleToggle = async (checked, record) => {
    setLoading(true);
    try {
      const payload = {
        OperationId: checked ? 2 : 4,
        CompanyId: userData.CompanyId,
        OrderModeId: record.OrderModeId,
        UserId: userData.UserId,
        UserIP: userData.UserIP,
      };
      const updatedOrderModes = await postRequest("/OrderModeCompanyMapping", payload);
      setOrderModes(updatedOrderModes?.data?.DataSet?.Table || []);
    } catch (error) {
      console.error("Toggle failed", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Order Mode Name",
      dataIndex: "OrderMode",
      key: "OrderModeName",
    },
    {
      title: "Status",
      key: "IsEnabled",
      render: (_, record) => (
        <Tag color={record.IsActive ? "green" : "red"}>
          {record.IsActive ? "On" : "Off"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>
        
        <Switch
          className="bg-gray-200"
          checked={record.IsActive}
          onChange={(checked) => handleToggle(checked, record)}
          />
        </>
      ),
    },
  ];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Order Mode</h1>
      <Table
        dataSource={orderModes}
        columns={columns}
        loading={loading}
        rowKey="OrderModeId"
        pagination={false}
        bordered
      />
    </div>
  );
};

export default OrderMode;
